import tbdcLogo from '../tbdc-logo1.1.png';
import fintechCadenceLogo from '../fintechcadence2-1.png';

export const partners = [
  {
    name: 'TBDC',
    focus: 'business Incubator',
    description: 'Toronto Business Development Centre',
    url: 'https://www.tbdc.com',
    logo: tbdcLogo,
    logoAlt: 'TBDC logo',
  },
  {
    name: 'Fintech Cadence',
    focus: 'Fintech Accelerator',
    description: 'Fintech Cadence',
    url: 'https://www.fintechcadence.com',
    logo: fintechCadenceLogo,
    logoAlt: 'Fintech Cadence logo',
  },
];
